import React, { Component } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { service } from '../State'
import Container from 'react-bootstrap/Container'
import { connect } from 'react-redux'
import * as act from "../Store/actions"
import * as com from "../Common.js"
import { tooltipFlat } from '../Common/Tooltip'
import { withRouter } from "react-router-dom";

import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { pointsExplained } from './ProductPicker'
const mapStateToProps = (state) => {
    return {
        hascoborrower: state.application.hascoborrower,
        cohabiting: state.application.cohabiting,
        application: state.application,
        property: state.application.property,
        selection: state.application.selection,
    }
}

const mapDispatchToProps = (dispatch) => ({

    changeBorrowerInfo: (event, who, verb) => {
        dispatch(act.ChangeBorrowerInfo(event.target.value, who, verb))
    },
    changeBorrowerInfoCheck: (event, who, verb) => {
        dispatch(act.ChangeBorrowerInfo(event.target.checked, who, verb))
    },
    changePhoneInfo: (input, who, verb) => {
        dispatch(act.ChangeBorrowerInfo(input, who, verb))
    },

    updatePreviousAddress: (event, who, verb, n) => {
        dispatch(act.UpdatePreviousAddress(event.target.value, who, verb, n))
    },
    addPreviousAddress: (event, who) => {
        dispatch(act.AddPreviousAddress(event.target.value, who,))
    },
    removePreviousAddress: (event, who, n) => {
        dispatch(act.RemovePreviousAddress(event.target.value, who, n))
    },
    clearPreviousAddress: (event, who) => {
        dispatch(act.ClearPreviousAddress(event.target.value, who))
    },
    changeMainProperty: (value, verb) => {
        dispatch(act.ChangeMainProperty(value, verb))
    },
    changeMainPropertyUnits: (event) => {
        dispatch(act.ChangeMainPropertyUnits(event.target.value))
    },
    changeMainPropertyYearBuilt: (event) => {
        dispatch(act.ChangeMainPropertyYearBuilt(event.target.value))
    },
    changeMainPropertyRefinanceYearAcquired: (event) => {
        dispatch(act.ChangeMainPropertyRefinanceYearAcquired(event))
    },
    changeMainPropertyRefinanceOriginalCost: (event) => {
        dispatch(act.ChangeMainPropertyRefinanceOriginalCost(event))
    },
    updateApplicationAttribute: (input, verb) => {
        dispatch(act.UpdateApplicationAttribute(input, verb))
    },
    updateSelectField: (input, verb) => {
        dispatch(act.UpdateSelectField(input, verb))
    },
    addSelectedLoanPrepaid: (service, chargename, period) => {
        dispatch(act.AddSelectedLoanPrepaid(service, chargename, period))
    },
    updatePaymentPeriod: (name, service, period) => {
        dispatch(act.UpdatePaymentPeriod(name, service, period))
    },
    updatePaymentAmount: (name, service, amount) => {
        dispatch(act.UpdatePaymentAmount(name, service, amount))
    },
    updatePrepaidDefault: (name, service, period, prepaidperiods, amount) => {
        dispatch(act.UpdatePrepaidDefault(name, service, period, prepaidperiods, amount))
    },
    addSelectedLoanEstimatedClosingCosts: (cc) => {
        dispatch(act.AddSelectedLoanEstimatedClosingCosts(cc))
    },


});


class LoanEstimate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ltv: 0,

            cltv: 0,
            hcltv: 0,

        }

        this.card = this.props.card

    }
    componentDidMount() {
        
    }
    getMergedDetail = () => {
        // 取出两个来源
        const cardDetail = this.card.closing_costs_detail || this.card.estimatedclosingcosts.closingCostsDetail || {};
        const propDetail = this.props.closingCostsDetail || {};
        // 需要合并的所有字段
        const fields = [
            'canNotShopServices',
            'canShopServices',
            'taxesAndOtherGovernmentFees',
            'originationCharges',
            'prepaids',
            'initialEscrowPaymentsAtClosing',
            'other'
        ];
    
        // 合并逻辑：同名字段合并为一个数组，去除 null/undefined
        const merged = {};
        fields.forEach(field => {
            const arr1 = Array.isArray(cardDetail[field]) ? cardDetail[field] : [];
            const arr2 = Array.isArray(propDetail[field]) ? propDetail[field] : [];
            merged[field] = [...arr1, ...arr2].filter(Boolean); // 过滤掉 null/undefined
        });
    
        return merged;
    }
    hasPrepaidInterest = () => {
        let cc = this.props.application.selection.estimatedclosingcosts
        if (null != this.card.estimatedclosingcosts)
            cc = this.card.estimatedclosingcosts

        let ret = false
        Object.keys(cc.prepaids).forEach(function (key) {

            if (cc.prepaids[key].paymentname === "Prepaid Interest" && cc.prepaids[key].amount !== 0) {
                ret = true
            }
        });
        return ret
    }


    canShopFor = () => {
        let cc = this.getMergedDetail()
        if (!cc) return null;
        if (!Array.isArray(cc.canShopServices)) cc.canShopServices = [];
    
        let total = 0;
        cc.canShopServices.forEach(function (item) {
            total += parseFloat(item.estimateAmount);
        });
        this.canShopForFee = total;
    
        let process = (item, index) => {
            return <Row xs="auto" key={"canshop" + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        };
    
        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">C. Services you can shop for:</Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat(total.toFixed(2))}
                    </Col>
                </Row>
                {cc.canShopServices.map(process)}
                <div>&nbsp;</div>
            </div>
        );
    }

    cantShopFor = () => {
        let cc = this.getMergedDetail()
        if (!cc) return null;
        if (!Array.isArray(cc.canNotShopServices)) cc.canNotShopServices = [];

        let total = 0
        cc.canNotShopServices.forEach(function (item) {
            total += parseFloat(item.estimateAmount)
        });
        this.cantShopForFee = total

        let process = (item, index) => {
            return <Row xs="auto" key={"canshopfor" + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        }

        return (
            <div>
                <Row >
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">B. Services you can't shop for:
                    </Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat(total.toFixed(2))}
                    </Col>
                </Row>
                {cc.canNotShopServices.map(process)}
                <div>&nbsp;</div>
            </div>
        )
    }
    totalLoanCost = () => {
        return (
            <div>
                <Row >
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">D. Total Loan Costs (A+B+C):
                    </Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat((this.cantShopForFee + this.canShopForFee + this.originationFees).toFixed(2))}
                    </Col>
                </Row>

                <div>&nbsp;</div>
            </div>
        )

    }
    otherTotal = () => {
        return (
            <div>
                <Row >
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">I. Total Other Costs (E + F + G + H):
                    </Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat((this.taxFees + this.prepaidFees + this.initialEscrowAtClosingFee +
                            this.otherFees).toFixed(2)
                        )}
                    </Col>
                </Row>

                <div>&nbsp;</div>
            </div>
        )
    }

    totalClosing = () => {

        let DI = this.cantShopForFee + this.canShopForFee + this.originationFees + this.taxFees + this.prepaidFees + this.initialEscrowAtClosingFee +
            this.otherFees

        this.totalclosingcosts = this.card.closing_cost

        let remaining_credits = 0
        if (this.totalclosingcosts < 0) {
            remaining_credits = this.totalclosingcosts
        }

        return (
            <div>
                <Row >
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">J. Total Closing Costs:
                    </Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat(this.totalclosingcosts.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>D + I
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(DI.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>Lender Credit</Col>
                    <Col xs="auto">
                        {this.props.card.points < 0
                            ? <>-${com.commaizeFloat(Math.abs(this.props.card.lender_credit).toFixed(2))}</>
                            : <></>
                        }
                    </Col>
                </Row>
                {remaining_credits < 0 ?
                    <Row>
                        <Col>Remaining Lender Credit
                        </Col>
                        <Col xs="auto" >
                            -${com.commaizeFloat(-remaining_credits.toFixed(2))}
                        </Col>
                    </Row>

                    : ""}
                <div>&nbsp;</div>
            </div>
        )
    }

    taxes = () => {
        let cc = this.getMergedDetail()
        if (!cc) return null;
        if (!Array.isArray(cc.taxesAndOtherGovernmentFees)) cc.taxesAndOtherGovernmentFees = [];
    
        let total = 0;
        cc.taxesAndOtherGovernmentFees.forEach(item => {
            total += parseFloat(item.estimateAmount);
        });
        this.taxFees = total;
    
        let process = (item, index) => (
            <Row key={"taxfee" + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        );
    
        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">E. Taxes and other government fees:</Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat(total.toFixed(2))}
                    </Col>
                </Row>
                {cc.taxesAndOtherGovernmentFees.map(process)}
                <div>&nbsp;</div>
            </div>
        );
    }

    originationCharges = () => {
        const detail = this.getMergedDetail();
        const originationCharges = detail.originationCharges || [];
    
        let total = 0;
        originationCharges.forEach(item => {
            total += parseFloat(item.estimateAmount);
        });
        this.originationFees = total;
    
        let process = (item, index) => (
            <Row key={item.serviceName + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        );
    
        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom">A. Origination charges:</Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat(this.originationFees.toFixed(2))}
                    </Col>
                </Row>
                {originationCharges.map(process)}
                <div>&nbsp;</div>
            </div>
        );
    }
    prepaids = () => {
        let cc = this.getMergedDetail();
        if (!cc) return null;
        if (!Array.isArray(cc.prepaids)) cc.prepaids = [];
    
        let total = 0;
        cc.prepaids.forEach(item => {
            total += parseFloat(item.estimateAmount);
        });
    
        this.prepaidFees = total;
    
        let displayPrepaid = (item, index) => (
            <Row key={item.serviceName + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        );
    
        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">F. Prepaids:</Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat(total.toFixed(2))}
                    </Col>
                </Row>
                {cc.prepaids.map(displayPrepaid)}
                <div>&nbsp;</div>
            </div>
        );
    }
    initialescrowatclosing = () => {
        let cc = this.getMergedDetail();
        if (!cc) return null;
        if (!Array.isArray(cc.initialEscrowPaymentsAtClosing)) cc.initialEscrowPaymentsAtClosing = [];
    
        let total = 0;
        cc.initialEscrowPaymentsAtClosing.forEach(item => {
            total += parseFloat(item.estimateAmount.toFixed(2));
        });
    
        this.initialEscrowAtClosingFee = total;
    
        let displayPrepaid = (item, index) => (
            <Row key={item.serviceName + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        );
    
        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">G. Initial Escrow Payments at Closing:</Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat(total.toFixed(2))}
                    </Col>
                </Row>
                {cc.initialEscrowPaymentsAtClosing.map(displayPrepaid)}
                <div>&nbsp;</div>
            </div>
        );
    }
    other = () => {
        let cc = this.getMergedDetail();
        if (!cc) return null;
        if (!Array.isArray(cc.other)) cc.other = [];
    
        let total = 0;
        cc.other.forEach(item => {
            total += parseFloat(item.estimateAmount);
        });
        this.otherFees = total;
    
        let process = (item, index) => (
            <Row xs="auto" key={item.serviceName + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        );
    
        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">H. Other:</Col>
                    <Col className="tabajacent "></Col>
                    <Col xs="auto" className="tabajacent ">
                        ${com.commaizeFloat(total.toFixed(2))}
                    </Col>
                </Row>
                {cc.other.map(process)}
                <div>&nbsp;</div>
            </div>
        );
    }
    cashtoclose = () => {
        let cc = this.props.application.selection.estimatedclosingcosts
        if ("undefined" !== typeof this.card.estimatedclosingcosts)
            cc = this.card.estimatedclosingcosts
        let getDownpayment = () => {

            if ("undefined" === typeof this.props.card.downpayment) {
                let customerfunds = 0

                switch (this.props.property.purpose) {
                    case "purchase":
                        customerfunds = this.props.selection.downpayment
                        break;
                    case "refinance":
                        customerfunds = this.props.selection.paydown
                        break;
                    case "cashoutrefinance":
                        customerfunds = this.props.selection.cashout
                        break;
                    default:
                        alert("should not see this!")
                        break;
                }
                return customerfunds
            }

            return this.props.card.downpayment + this.props.card.paydown
        }
        this.finalCashToClose = this.totalclosingcosts + parseFloat(cc.closingcostsfinanced) + getDownpayment() +
            parseFloat(cc.deposit) + parseFloat(cc.fundsforborrower) + parseFloat(cc.sellerscredits)
            + parseFloat(cc.adjustmentsothercredits)

        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">Calculating Cash to Close:
                    </Col>
                    <Col className="tabajacent "></Col>
                </Row>
                <Row>
                    <Col>Total closing costs (J)
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(this.totalclosingcosts.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>Closing costs financed
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(cc.closingcostsfinanced.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>Downpayment/Funds from borrower
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(getDownpayment().toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>Deposit
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(cc.deposit.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>Funds for Borrower
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(cc.fundsforborrower.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>Seller's Credits
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(cc.sellerscredits.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>Adjustments/Other credits
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(cc.adjustmentsothercredits.toFixed(2))}
                    </Col>
                </Row>
                <div>&nbsp;</div>
                <Row className="border-bottom border-dark">
                    <Col>
                    </Col>
                    <Col>
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontWeight: 'bold' }}>
                        Cash to close:
                    </Col>
                    <Col xs="auto" style={{ fontWeight: 'bold' }}>
                        ${com.commaizeFloat(this.finalCashToClose.toFixed(2))}
                    </Col>
                </Row>
            </div>
        )
    }
    getLoanSize = () => {
        let card = this.props.card
        if ("undefined" !== typeof (card.loansize))
            return parseFloat(card.loansize)

        return parseFloat(this.props.application.selection.loansize)
    }
    render = () => {
        return <div className="py-2 px-0">
            <Row>
                <Col style={{ width: '70%' }}>
                    <h2 className="heading mb-4">Closing costs are what you pay for points, fees and services to close your loan.</h2>
                </Col>
            </Row>
            <Row>
                <Col xs="auto" className="px-0 mx-0">
                    {this.originationCharges()}
                    {this.cantShopFor()}
                    {this.canShopFor()}
                    {this.totalLoanCost()}
                    {this.taxes()}
                    {this.prepaids()}
                    {this.initialescrowatclosing()}
                    {this.other()}
                    {this.otherTotal()}
                    {this.totalClosing()}
                    {this.cashtoclose()}

                </Col>
                <Col xs="auto" className="p-5 ">
                <div className="disclaimer-text">
                    Disclaimer: The closing costs provided are estimates only and are subject to change. Actual costs may vary based on final lender fees, third-party charges, and other factors.
                </div>
                </Col>
            </Row>
        </div>
    }
}
class LoanDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ltv: 0,
            cltv: 0,
            hcltv: 0,

        }
        // calculate the set of tasks
        this.yearstohold = Math.min(parseInt(this.props.application.keepinghousefor), parseInt(this.props.card.Term))
        if (isNaN(this.yearstohold))
            this.yearstohold = 7
        this.card = this.props.card
    }


    displaySelectedCard = () => {
        let card = this.props.card

        let getType = () => {

            if (card.amortization === "fixed" || card.MortgageAmortization === "fixed")
                return "Fixed rate"

            return "ARM " + card.Arm.fixedperiod + "/6"
        }
        let getLoanSize = () => {
            if ("undefined" !== typeof (card.loansize))
                return parseFloat(card.loansize)

            return parseFloat(this.props.application.selection.loansize)
        }
        let loansize = parseInt(getLoanSize())
        let interest10 = com.getClosedInterestPaid(0.01 * card.base_rate, loansize, card.Term, this.yearstohold)
        let interesttotal = com.getClosedInterestPaid(0.01 * card.base_rate, loansize, card.Term, card.Term)
        let purposeOfLoan = () => {
            switch (this.props.application.property.purpose) {
                case "purchase": {
                    return "Purchase"
                }
                case "refinance": {
                    return "Refinance to improve rate or term"
                }
                case "cashoutrefinance": {
                    return "Cash out refinance"
                }
                default: return "Unknown"
            }
        }

        let getDownpayment = () => {

            if ("undefined" === typeof this.props.card.downpayment) {
                let customerfunds = 0

                switch (this.props.property.purpose) {
                    case "purchase":
                        customerfunds = this.props.selection.downpayment
                        break;
                    case "refinance":
                        customerfunds = this.props.selection.paydown
                        break;
                    case "cashoutrefinance":
                        customerfunds = this.props.selection.cashout
                        break;
                    default:
                        return ''
                }
                return customerfunds
            }

            return this.props.card.downpayment + this.props.card.paydown
        }
        let getPaydown = () => {
            let cc = this.props.application.selection
            if (null !== cc.selectedloan)
                cc = cc.selectedloan
            switch (this.props.application.property.purpose) {
                case "purchase":
                    return <div> Downpayment<br /> ${com.commaizeFloat(getDownpayment().toFixed(2))} </div>

                case "refinance":
                    return <div> Paydown principal<br /> ${com.commaizeFloat(getDownpayment().toFixed(2))} </div>

                case "cashoutrefinance":
                    return <div> Cash out<br /> ${com.commaizeFloat(getDownpayment().toFixed(2))} </div>
                default:
                    alert("should not see this!")
                    return 0
            }
        }
        let getPMINeed = () => {
            let pmi = card.PMICost
            if ("undefined" !== typeof card.pmi) {
                pmi = card.pmi
            }
            return pmi
        }
        let getPMI = () => {
            let pmi = card.PMICost
            if ("undefined" !== typeof card.pmi) {
                pmi = card.pmi
            }
            if (0 === pmi)
                return "Not required"

            return <span>${com.commaizeFloat(pmi)} </span>
        }
        let getCurrentRate = () => {
            let rate = 0
            const loans = this.props?.application?.assetsandliabilities?.loans || []
            for (let i = 0; i < loans.length; i++) {
                let cc = loans[i]

                if (cc.forsubjectproperty && this.props.application.property.purpose !== "purchase") {
                    rate = cc.rate
                }
            }
            return rate
        }
        let getAppraisal = () => {
            return parseFloat(this.props.application.property.appraisal)
        }
        let getLenderCredit = () => {
            if (card.closing_cost > 0)
                return 0
            return - parseFloat(card.closing_cost)
        }
        let getCurrentProgram = () => {
            switch (this.props.application.property.refinance.currentprogram) {
                case "fixed": return "Fixed rate"
                case "arm": return "ARM"
                case "baloon": return "Baloon"
                case "heloc": return "HELOC"
                case "negativeamortization": return "Negative Amortization"
                case "interestonly": return "Interest Only"
                case "noloan": return "No current loan"
                default: return "No current loan specified"
            }
        }
        let getPrepaidInterest = () => {
            return card.prepaid_interest
        }
        return <div className="mb-4 mt-2">
            <Container key={card.hash} className=" drop-shadow w-100 p-3 my-5 text-left">

                <Row>
                    <Col className="loancard pt-2 ">
                        <b>Purpose of Loan:</b><br />
                        {purposeOfLoan()}
                    </Col>
                    <Col className=" loancard pt-2">
                        <b>Loan amount:</b><br />
                        ${com.commaizeFloat(getLoanSize().toFixed(2))}
                    </Col>
                    <Col className=" loancard pt-2">
                        <b>Estimated Market Value:</b><br />
                        ${com.commaizeFloat(getAppraisal().toFixed(2))}
                    </Col>
                    {
                        this.props.application.property.purpose === "purchase" ?
                            <Col className="border-top loancard pt-2"><b>Purchase Price:</b><br />${com.commaize(this.props.application.property.salesprice)}</Col>
                            : ""
                    }
                    <Col className="border-bottom  loancard pt-2">
                        {getPaydown()}
                    </Col>
                </Row>
                {
                    (this.props.application.property.purpose !== "purchase") ?
                        <Row >
                            <Col xs="auto" className="border-bottom border-top loancard py-2" >
                                Current Program: {getCurrentProgram()}
                            </Col>

                            {getCurrentRate() !== 0 ?
                                <Col xs="auto" className="border-bottom border-top loancard py-2" >
                                    Current Rate: {getCurrentRate()}%
                                </Col> : ""}
                            <Col className="border-bottom border-top loancard py-2" >
                            </Col>

                        </Row>
                        : ""
                }
                <Row>
                    <Col className="border-bottom border-top loancard py-2" >
                        Subject property: {this.props.application.property.address}
                    </Col>
                </Row>

                <Row className=" text-left ">
                    <Col className="border-bottom border-top loancard pt-2 ">
                        <b>{getType()}</b><br />
                        <b>{card.Term} years</b>
                    </Col>
                    <Col className="border-bottom border-top loancard pt-2 ">
                        Rate:<br />
                        <b>{card.base_rate}%</b>
                    </Col>
                    <Col className="border-bottom border-top loancard pt-2 ">
                        APR:<br />
                        <b>{card.APR}%</b>
                    </Col>
                    <Col className="border-bottom border-top loancard pt-2 ">
                        Monthly Payment (P&amp;I):<br />
                        <b>${com.commaizeFloat(card.monthly_payment.toFixed(2))}</b>
                    </Col>
                    <Col className="border-bottom border-top loancard pt-2 ">
                        Closing Costs:<br />
                        <b>${com.commaizeFloat(card.closing_cost.toFixed(2))}</b>
                    </Col>

                </Row>
                <Row className="text-left ">

                    <Col className="border-bottom  py-2 loancard">
                        Interest over<br />{this.yearstohold} years:<br />
                        <b>${com.commaizeFloat(interest10.toFixed(2))}</b>
                    </Col>
                    <Col className="border-bottom py-2 loancard">
                        Interest over<br />loan life:<br />
                        <b>${com.commaizeFloat(interesttotal.toFixed(2))}</b>
                    </Col>

                    {/* <Col className="border-bottom py-2 loancard">
                        Prepaid interest:<br />
                        <b>${com.commaizeFloat(getPrepaidInterest())}</b>
                    </Col> */}

                    <Col className="border-bottom py-2 loancard">
                        Mortgage Type:<br />
                        <b className="">{com.capitalize(card.Mtype.replace('_', ' ').toLowerCase().replace('fha', 'FHA'))}</b>
                    </Col>
                    <Col className="border-bottom py-2 loancard">
                        Points:<br />
                        <b className="capitalize">{card.points.toFixed(3)}</b>
                    </Col>

                </Row>
                <Row>
                    <Col className="border-bottom  loancard pt-2 ">
                        <b>Remaining lender credit:</b><br />
                        <b>${com.commaizeFloat(getLenderCredit().toFixed(2))} </b>
                    </Col>
                    {card.lender_fee ?
                        <Col className="border-bottom  loancard pt-2 ">
                            <b>Lender fee:</b><br />
                            <b>${com.commaizeFloat(card.lender_fee.toFixed(2))}</b>
                        </Col> : <Col></Col>
                    }



                    <Col className="border-bottom loancard pt-2 ">
                        <b>Minimal reserves:</b><br />
                        <b>{card.min_months_reserves} months</b>
                    </Col>

                    <Col className="border-bottom loancard pt-2 ">
                        <b>Prepaid interest:</b><br />
                        <b>${com.commaizeFloat(card.prepaid_interest.toFixed(2))} </b>
                    </Col>

                    <Col className="border-bottom loancard pt-2 ">
                        <b>Lock period:</b><br />
                        <b>{card.lockDay} days</b>
                    </Col>
                </Row>

                <Row>

                    {getPMINeed() !== 0 ?
                        <Col className=" loancard pt-2 ">
                            <b>PMI Insurance:</b><br />
                            <b>{getPMI()} </b>
                        </Col> : ""}
                    {card.FHAMIP != null ?

                        <Col xs="auto" className=" loancard pt-2 ">
                            <b>Upfront Mortgage Insurance Premium :</b><br />
                            <b>{card.FHAMIP.upfrontMIP} </b>
                        </Col> : ""}
                    {card.FHAMIP != null ?
                        <Col xs="auto" className=" loancard pt-2 ">
                            <b>Monthly Mortgage Insurance Premium :</b><br />
                            <b>{card.FHAMIP.monthlyMIP} </b>
                        </Col>

                        : ""}
                    <Col>
                    </Col>
                    <Col>
                    </Col>
                    <Col>
                    </Col>
                </Row>
            </Container>
        </div>

    }
    render() {

        return (
            <div className="mb-3 px-1 text-center">

                <Row>
                    <Col> {this.displaySelectedCard()} </Col>
                </Row>


            </div>
        )
    }
}
LoanDetails = withRouter(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(LoanDetails))
LoanEstimate = withRouter(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(LoanEstimate))
class Details extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }
    componentDidMount() {

    }

    componentWillUnmount() { }


    handleSubmit = e => {
        return true
    }


    render() {

        return (
            <Tabs className="border  border-top border-left border-right text-dard estimated-fee-sheet" transition={false}
                id="detalstabs" unmountOnExit={true} >
                <Tab eventKey="upfrontfees" title="Closing Cost Details" className="text-dark border" >
                    <LoanEstimate card={this.props.card} closingCostsDetail={this.props.closingCostsDetail} />
                </Tab>
                <Tab eventKey="loandetails" title="Overview" className="text-dark border" >
                    <LoanDetails card={this.props.card} />
                </Tab>


            </Tabs>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Details)

